import React, { useContext } from "react";
import { AuthContext } from "../Admin/AuthContext";

export const withAuth = (WrappedComponent) => (props) => {
  const auth = useContext(AuthContext);
  
  // Show loading screen while checking token
  if (auth.isLoading) {
    return <div>Loading...</div>;
  }
  
  return <WrappedComponent {...props} auth={auth} authenticated={auth.authenticated} currentUser={auth.currentUser} />;
};


// WEBPACK FOOTER //
// ./src/Components/Auth/WithAuth.js